import React, { useEffect, useState } from "react"
import { Container, Row, Col, Button, Card, Form } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { getClients } from "../actions/other/clientsActions"
import { RootState, AppDispatch } from "../store"

import { CustomDataTable } from "../components/design/Datatables/CustomDataTable"
import Loader from "../components/loaders/Loader"

export interface Client {
	_id?: string
	id?: string
	nombreCompleto?: string
	direccion?: string
	poblacion?: string
	cifNif?: string
}

export default function Clients() {
	const { t } = useTranslation()
	const dispatch: AppDispatch = useDispatch()
	const navigate = useNavigate()

	const {clients, loading	, total	} = useSelector((state: RootState) => state.clients)

	const [page, setPage] = useState(1)
	const [limit, setLimit] = useState(25)
	const [search, setSearch] = useState<any>({})
	const [sort, setSort] = useState<any>(null)

	const [cifNif, setCifNif] = useState("")
	const [telefono, setTelefono] = useState("")
	const [nombreCompleto, setNombreCompleto] = useState("")
	const [totalRows, setTotalRows] = useState(0)


	/* ===============================
	   BUSCAR CLIENTE
	=============================== */
	const handleSearch = () => {
		dispatch(getClients(1, 999999, search) as any)
	}

	useEffect(() => {
		setTotalRows(total || 0)
	}, [total])

	const selectClient = (client: Client) => {
		navigate(`${client.id}`)
	}

	/* ===============================
	   COLUMNAS TABLA
	=============================== */

	const columnsClient = [
		{
			name: t("clientTranslate.cifNif"),
			id: "cifNif",
			width: "150px",
			cell: (c: Client) => (
				<div className="cursor text-start" onClick={() => selectClient(c)}>
					{c?.cifNif || "—"}
				</div>
			),
			selector: (c: Client) => c?.cifNif || "—",
			sortable: true,
		},
		{
			name: t("clientTranslate.nombreCompleto"),
			id: "nombreCompleto",
			cell: (c: Client) => (
				<div className="cursor text-start" onClick={() => selectClient(c)}>
					{c?.nombreCompleto || "—"}
				</div>
			),
			selector: (c: Client) => c?.nombreCompleto || "—",
			sortable: true,
		},
		{
			name: t("clientTranslate.direccion"),
			id: "direccion",
			cell: (c: Client) => (
				<div className="cursor text-start" onClick={() => selectClient(c)}>
					{c?.direccion || "—"}
				</div>
			),
			selector: (c: Client) => c?.direccion || "—",
			sortable: true,
		},
		{
			name: t("clientTranslate.municipio"),
			id: "poblacion",
			cell: (c: Client) => (
				<div className="cursor text-start" onClick={() => selectClient(c)}>
					{c?.poblacion || "—"}
				</div>
			),
			selector: (c: Client) => c?.poblacion || "—",
			sortable: true,
		},
	]

	return (
		<Container className="p-1 py-5 p-md-5">
			<Row>
				<Col xs={12}>
					<h1>{t("menus.clients")}</h1>
				</Col>
			</Row>

			{/* BUSCADOR */}
			<Row>
				<Col xs={12} className="my-3">
					<Card>
						<Card.Body>
							<Row className="justify-content-between">
								<Col xs={10}>
									<Row>
										<Col>
											<Form.Control
												className="text-uppercase"
												placeholder={t("clientTranslate.cifNif")}
												value={cifNif}
												onChange={e => {
													const val = e.target.value.toUpperCase();
													setCifNif(val)
													setSearch({ ...search, cifNif: val })
												}}
												onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
													if (e.key === "Enter") {
														setSearch({...search, cifNif: cifNif});
														setPage(1);
														handleSearch();
													}
												}}
											/>
										</Col>
										<Col>
											<Form.Control
												className="text-uppercase"
												placeholder={t("clientTranslate.nombre")}
												value={nombreCompleto}
												onChange={e => {
													const val = e.target.value.toUpperCase();
													setNombreCompleto(val)
													setSearch({
														...search,
														nombreCompleto: val,
													})
												}}
												onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
													if (e.key === "Enter") {
														setSearch({...search, nombreCompleto: nombreCompleto});
														setPage(1);
														handleSearch();
													}
												}}
											/>
										</Col>
										<Col>
											<Form.Control
												placeholder={t("clientTranslate.telefonoOCorreo")}
												value={telefono}
												onChange={e => {
													setTelefono(e.target.value)
													setSearch({ ...search, telefono: e.target.value })
												}}
												onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
													if (e.key === "Enter") {
														setSearch({...search, telefono: telefono});
														setPage(1);
														handleSearch();
													}
												}}
											/>
										</Col>
									</Row>
								</Col>

								<Col xs={2} className="text-end">
									<Button onClick={handleSearch} className="button-search">
										<i className="fas fa-search" />
									</Button>
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			{/* TABLA */}
			<Row>
				<Col>
					<Card>
						<Card.Body>
							{loading ? (
								<Loader />
							) : clients?.length ? (
								<CustomDataTable
									columns={columnsClient}
									data={clients}
									pagination
								/>
							) : (
								<p className="text-center m-0">
									{t("clientTranslate.thereisnotclient")}
								</p>
							)}
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	)
}
